// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDMKpoVsw_e1qLTkH9KLhCL4RXPc0gHFUE',
  authDomain: 'bucksapop.firebaseapp.com',
  databaseURL: 'https://bucksapop.firebaseio.com',
  projectId: 'bucksapop',
  storageBucket: 'bucksapop.appspot.com',
  messagingSenderId: '426430227364',
  appId: '1:426430227364:web:7a2a1a88d02827aa135731',
  measurementId: 'G-X7DWDS1G8F'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
